"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var domparser_1 = __importDefault(require("./domparser"));

var utilities_1 = require("./utilities");

var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param html - HTML markup.
 * @returns - DOM elements.
 */

function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!html) {
    return [];
  } // match directive


  var match = html.match(DIRECTIVE_REGEX);
  var directive = match ? match[1] : undefined;
  return (0, utilities_1.formatDOM)((0, domparser_1.default)(html), null, directive);
}

exports.default = HTMLDOMParser;